import {push} from 'react-router-redux'
import {DEFAULT_PATRIMONY_QUERY, loadPatrimonyStream, queryPatrimonyStream, queryMinorContactStream, updateReferencePatrimonyContactCmd} from './actions'

function criteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        const nextCriteria = state.patrimony.criteria

        if (nextCriteria != criteria) {

            if (nextCriteria.agencyUids != (criteria && criteria.agencyUids)) {
                const location = state.router.location

                dispatch(loadPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...nextCriteria})).then(() => {
                    if (location.pathname != '/patrimonies') {
                        dispatch(push('/patrimonies'))
                    }
                })
            }
            criteria = nextCriteria
        }
    }
}

function minorCriteriaUpdated() {
    var minorCriteria

    return (state, dispatch) => {
        const nextMinorCriteria = state.patrimony.minorCriteria

        if (nextMinorCriteria != minorCriteria) {

            if (nextMinorCriteria && nextMinorCriteria.agencyUids != (minorCriteria && minorCriteria.agencyUids)) {
                dispatch(queryPatrimonyStream(nextMinorCriteria))
            }
            minorCriteria = nextMinorCriteria
        }
    }
}

function minorContactCriteriaUpdated() {
    var minorCriteria

    return (state, dispatch) => {
        const nextMinorCriteria = state.patrimony.contact.minorCriteria

        if (nextMinorCriteria != minorCriteria) {

            if (nextMinorCriteria && nextMinorCriteria.patrimonyUids != (minorCriteria && minorCriteria.patrimonyUids)) {
                dispatch(queryMinorContactStream(nextMinorCriteria))
            }
            minorCriteria = nextMinorCriteria
        }
    }
}

function referencePatrimonyContactCmdUpdated() {
    var cmd

    return (state, dispatch) => {
        const nextCmd = state.patrimony.referencePatrimonyContactCmd

        if (nextCmd != cmd) {

            if (nextCmd && nextCmd.linkedWithEntities != (cmd && cmd.linkedWithEntities)) {
                switch(nextCmd.linkedWithEntities.linkType) {
                    case 'LinkToLotAsTenant':
                    case 'LinkToPatrimonyAsCareTaker':
                    case 'LinkToPatrimonyAsHomeOwnerAssociation':
                        dispatch(updateReferencePatrimonyContactCmd({linkedWithPatrimonyAsHomeOwnerAssociation: null}))
                        break
                }
            }
            cmd = nextCmd
        }
    }
}

export default [criteriaUpdated(), minorCriteriaUpdated(), minorContactCriteriaUpdated(), referencePatrimonyContactCmdUpdated()]


// WEBPACK FOOTER //
// ./lib/patrimony/actors.js